import React from 'react';
import styled from 'astroturf/react';
import { Button } from 'js/design_system/Button';

import Icon from 'js/svg/colorful/cited_paper_puddle.svg';
import _Container from "common-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/churned_user_reactivation/common.tsx?styleId=Container";
import _TextContainer from "common-TextContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/churned_user_reactivation/common.tsx?styleId=TextContainer";
import _IconSpan from "common-IconSpan.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/churned_user_reactivation/common.tsx?styleId=IconSpan";
import _Text from "common-Text.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/churned_user_reactivation/common.tsx?styleId=Text";
import _ActionButton from "common-ActionButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/churned_user_reactivation/common.tsx?styleId=ActionButton";
import _CloseButton from "common-CloseButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/unibrows/churned_user_reactivation/common.tsx?styleId=CloseButton";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const TextContainer = /*#__PURE__*/styled("div", null, {
  displayName: "TextContainer",
  styles: _TextContainer
});

const IconSpan = /*#__PURE__*/styled("span", null, {
  displayName: "IconSpan",
  styles: _IconSpan
});

const Text = /*#__PURE__*/styled("div", null, {
  displayName: "Text",
  styles: _Text
});

const ActionButton = /*#__PURE__*/styled(Button, null, {
  displayName: "ActionButton",
  styles: _ActionButton
});

const CloseButton = /*#__PURE__*/styled("div", null, {
  displayName: "CloseButton",
  styles: _CloseButton
});

type Props = {
  ctaText: string;
  buttonText: string;
  clickThrough: () => void;
  hide: () => void;
};

export const CommonUnibrow = ({
  ctaText,
  buttonText,
  clickThrough,
  hide,
}: Props) => {
  return (
    <Container className="DesignSystem">
      <TextContainer>
        <IconSpan>
          <Icon />
        </IconSpan>
        <Text>{ctaText}</Text>
      </TextContainer>
      <ActionButton inverse onClick={clickThrough}>
        {buttonText}
      </ActionButton>
      <CloseButton onClick={hide}>&times;</CloseButton>
    </Container>
  );
};
